var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"tableTitle":_vm.tableTitle,"searchBtn":false,"form":_vm.form,"back":_vm.back,"pageFooter":true,"searchTime":false,"addHref":_vm.addHref,"deleteUrl":_vm.deleteUrl,"searchUrl":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }